import API from './../api';

export default {
    namespaced: true,

    state() {
        return {
            isTravelInsuranceEnabled: false,
            metadata: {},metadata: {},
        };
    },

    getters: {
        travelInsuranceStatus: state => state.isTravelInsuranceEnabled,
        metadata: (state) => state.metadata,
    },

    mutations: {
        setInsuranceStatus(state, response) {
            state.isTravelInsuranceEnabled =
                response.data && response.data.active;
        },
        gotMetadata(state, response) {
            state.metadata = response.data || {};
        },        
    },

    actions: {
        async fetchMetadata({ commit }) {
            commit('gotMetadata', await API.get('/app/travel-insurance/metadata/'));
        },        
        async fetchStatus({ commit }) {
            commit(
                'setInsuranceStatus',
                await API.get(`app/travel-insurance/issuances-setup/status`)
            );
        },
    },
};
